// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'

// Internal Dependencies:
import Share from 'components/share/share'
import { getScrollbarWidth } from 'utilities/scrollbar'

// Redux:
import { closeMenu } from 'actions/site'
import { getPageData } from 'actions/page'
import { currentPage } from 'selectors/page'

const menuItems = safeSiteData.site_menu
const menuClass = '-menu'

class Menu extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			itemClicked: false
		}
	}

	componentDidMount() {
		this.scrollbarWidth = getScrollbarWidth()
	}

	componentDidUpdate() {
		const { menuIsOpen } = this.props

		if ( menuIsOpen ) {
			document.documentElement.classList.add( 'with-site-menu-open' )
			document.documentElement.style.paddingRight = this.scrollbarWidth + 'px'
		} else {
			document.documentElement.classList.remove( 'with-site-menu-open' )
			document.documentElement.style.paddingRight = 0
		}
	}

	handleMenuItemClick = () => {
		this.props.handleCloseMenu()

		document.activeElement.blur()
	}

	handleMenuItemHover = ( e ) => {
		let slug = e.currentTarget.getAttribute( 'data-id' )

		// this.props.getPost( slug )
	}

	renderLink( item ) {
		let linkMarkup

		if ( '/' === item.url ) {
			linkMarkup = (
				<NavLink
					to='/'
					exact
					activeClassName="is-active"
					onClick={ this.handleMenuItemClick }
					dangerouslySetInnerHTML={ { __html: item.title } }
				/>
			)
		} else if ( item.url.indexOf( '//' ) > -1 ) {
			linkMarkup = (
				<a href={ item.url } target="_blank" onClick={ this.handleMenuItemClick }>
					{ icon }
					{ item.title }
				</a>
			)
		} else {
			linkMarkup = (
				<NavLink
					to={ item.url }
					exact
					activeClassName="is-active"
					onClick={ this.handleMenuItemClick }
					onMouseOver={ this.handleMenuItemHover }
					data-id={ item.url }
					dangerouslySetInnerHTML={ { __html: item.title } }
				/>
			)
		}

		return linkMarkup
	}

	render() {
		const { itemClicked } = this.state
		let wrapClass = this.props.menuIsOpen ? 'on-mobile-is-active primary-menu-wrap' : 'primary-menu-wrap'
		var menuItemsMarkup = ''

		if ( itemClicked ) {
			wrapClass += ' is-clicked'
		}

		if ( menuItems && Object.keys( menuItems ).length ) {
			menuItemsMarkup = Object.keys( menuItems )
				.map( ( key ) => {
					// Top level:

					let e = menuItems[ key ],
						childrenMarkup = '',
						linkMarkup = this.renderLink( e )

					if ( e.children && Object.keys( e.children ).length ) {
						// Children:

						let childrenItemsMarkup = Object.keys( e.children )
							.map( ( key ) => {
								let childLinkMarkup = this.renderLink( e.children[ key ] )

								return (
									<li key={ key }>
										{ childLinkMarkup }
									</li>
								)
							})

						childrenMarkup = (
							<div className="-dropdown">
								<ul>
									{ childrenItemsMarkup }
								</ul>
							</div>
						)
					}

					return (
						<li key={ key }>
							{ linkMarkup }
							{ childrenMarkup }
						</li>
					)
				})
		}

		const menuItemsMarkupMobile = [
			<li key="social">
				<div className="-social">
					<a href="https://www.facebook.com/SAFEpetsAU" target="_blank" rel="noopener">
						<span className="u-screen-reader-text">Facebook</span>
						<i className="icon-facebook-square" arua-hidden="true"></i>
					</a>

					<a href="https://www.instagram.com/safe_inc/" target="_blank" rel="noopener">
						<span className="u-screen-reader-text">Instagram</span>
						<i className="icon-instagram" arua-hidden="true"></i>
					</a>

					<a href="https://www.youtube.com/channel/UCvbgZD9Up_bbEX4WdPevpoQ" target="_blank" rel="noopener">
						<span className="u-screen-reader-text">YouTube</span>
						<i className="icon-youtube-square" arua-hidden="true"></i>
					</a>

					<a className="is-google-bus" href="https://www.google.com/search?q=Saving+Animals+from+Euthanasia+Inc.+(SAFE+Inc)&stick=H4sIAAAAAAAA_-NgU1I1qDBKSjMzNDVKM01LMzQ0sEixAgqlWqSaGqYkp1qaGpgYGKcuYtULTizLzEtXcMzLzE3MKVZIK8rPVXAtLclIzEsszkxU8MxL1lPQCHZ0cwUxNQGjDsluWgAAAA&hl=en-GB&mat=CQoy_eg1Ow_AElcB7PxHsQXBonIcxF4MXpO4n_7DUb6ON6sGWe31vHdlBP1z7kIDhgXJgupnd08_fkJ5P2uz1rNme3IVub026Gku34ROLJ5Pg7czxwS-5PffDMpa-lXzvOY&authuser=0&ved=2ahUKEwj3-bDXs5aFAxVPTWwGHbXtAdUQ-MgIegQIFRAd" target="_blank" rel="noopener">
						<span className="u-screen-reader-text">Google Business</span>
						<img src={ `${safeSiteData.images_url}icons/google-my-business.svg` } alt="" />
					</a>
				</div>
			</li>,
			<li key="donate">
				<Link to="/donate" className="donate-button" onClick={ this.handleMenuItemClick }>Donate</Link>
			</li>,
			<li key="shop">
				<a href="https://www.safewa.org.au/" className="donate-button" target="_blank" rel="noopener">Shop</a>
			</li>
		]

		return (
			<div className={ wrapClass }>
				<div className="primary-menu">
					<ul className={ menuClass }>
						{ menuItemsMarkup }
						{ window.innerWidth <= safeSiteData.mobile_max_width && menuItemsMarkupMobile }
					</ul>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		menuIsOpen: state.site.menuIsOpen,
		page: currentPage( state )
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleCloseMenu() {
			dispatch( closeMenu() )
		},

		getPost: ( slug ) => {
			dispatch( getPageData( slug, 'page', false, true ) )
		},
	}
}

// export default connect( mapStateToProps, mapDispatchToProps, null, { pure: false } )( Menu )
export default connect( mapStateToProps, mapDispatchToProps )( Menu )



// WEBPACK FOOTER //
// ./components/menu/menu.jsx